import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import clxBind from 'classnames/bind';
import Button from '../Button';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class CheckBox extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['check', 'button']),
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    halfChecked: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    type: 'check',
    disabled: false,
    checked: false,
    halfchecked: false,
    value: undefined,
    onChange: undefined,
    className: undefined,
    children: null,
  };

  handleChange = event => {
    const { value, onChange } = this.props;
    const checked = get(event, 'target.checked');

    if (!onChange) {
      return;
    }

    if (checked) {
      if (value) {
        onChange(value);
      } else {
        onChange(checked);
      }
    } else {
      onChange('');
    }
  };

  render() {
    const { type, disabled, checked, halfchecked, className, children, ...props } = this.props;

    const labelClasses = clx(
      'check-box',
      {
        disabled,
        checked,
        halfchecked,
      },
      className
    );

    switch (type) {
      case 'button':
        return (
          <Button type="check" disabled={disabled} checked={checked} {...props}>
            {children}
          </Button>
        );
      default:
        return (
          <label className={labelClasses} htmlFor={props.id}>
            <span className={styles['check-box-inner']}>
              <input
                type="checkbox"
                className={styles['input']}
                disabled={disabled}
                checked={checked}
                {...props}
              />
            </span>
            {children}
          </label>
        );
    }
  }
}
